<template>
  <div>
    <qx-card title="资金风控查看" class="detail" v-loading="loading">
      <!-- 订单详情数据 -->
      <section v-if="!loading">
        <qx-detail-box
          v-for="(data, index) in detailData"
          :data="data"
          :key="index"
          labelWidth="220px"
        />
        <!-- 订单详情数据 end -->
      </section>
      <ApproveBox
        v-show="type === 'approve' || approveFlag"
        :busiId="id ? String(id) : String(userInfo.staffTFInfo.tenantId)"
        busiCode="100003"
        :customCancel="true"
        :costomSuccess="true"
        @cancel="approveFlag = false"
        @success="getData"
        :inFast="Boolean(id)"
        :handleRefresh="handleRefresh"
      />
      <p class="textCenter" v-show="!approveFlag">
        <el-button type="primary" @click="toEdit" v-if="checkPermpisions('1100702')">修改</el-button>
        <el-button
          type="primary"
          @click="approveFlag = true"
          v-show="approveBtnState"
          v-if="checkPermpisions('1100703')"
        >审核</el-button>
      </p>
    </qx-card>
  </div>
</template>

<script>
import {
  riskCapital, // 详情数据接口
  riskCapitalApproveData, // 审核数据
} from 'api/system';
import ApproveBox from 'components/approveBox';
import {
  mapState,
} from 'vuex';
export default {
  components: {
    ApproveBox,
  },
  props: {
    id: {
      type: Number,
    },
    type: {
      type: String,
    },
    handleRefresh: {
      type: Function,
      default: () => {},
    },
  },
  data () {
    return {
      loading: false,
      approveFlag: false,
      approveBtnState: false,
      detailData: {
        order: {
          label: '订单支出',
          tableData: {
            title: [
            ],
            data: {

            },
            approveData: {

            },
          },
        },
        driver: {
          label: '司机工资',
          tableData: {
            title: [
            ],
            data: {

            },
            approveData: {

            },
          },
        },
        member: {
          label: '会员消费',
          tableData: {
            title: [
            ],
            data: {

            },
            approveData: {

            },
          },
        },
        account: {
          label: '自动打款与付款账户',
          tableData: {
            title: [
            ],
            data: {

            },
            approveData: {

            },
          },
        },
      },
    };
  },
  computed: {
    colSpan () {
      const total = 24;
      const minSpan = 4;
      return parseInt(total / this.orderInfo.length, 10) < minSpan ? minSpan : parseInt(total / this.orderInfo.length, 10);
    },
    ...mapState({
      userInfo: (state) => state.user.userInfo, // 用户信息
    }),
  },
  methods: {
    toEdit () {
      this.jump({
        label: '修改资金风控',
        url: '/manage/system/risk/money/edit?id=1',
      });
    },
    async getOrderData () {
      // 订单支出 - 原始数据
      const orderRes = await riskCapital({
        codeType: 'PAY_FEE_LIMIT_SUB_TYPE',
        codeDesc: 1,
        state: 1,
      });
      if (!orderRes.failed) {
        this.detailData.order.tableData.title = [];
        orderRes.items.forEach((item, index) => {
          let remark = '';
          switch (index) {
            case 0:
              remark = '如果运费超过此上限，系统不允许开单。';
              break;
            case 1:
              remark = '在新增异常时对承运方赔钱，如果金额超过此上限，系统不允许提交。';
              break;
            case 2:
              remark = '新增异常时对发货方赔钱，如果金额超过此上限，系统不允许提交。';
              break;
            case 3:
              remark = '如果司机借支金额超过此上限，系统不允许借支。';
              break;
            default:
              break;
          }
          this.detailData.order.tableData.title.push({
            prop: `order${index}`,
            label: item.subTypeName,
            remark,
          });
          this.detailData.order.tableData.data[`order${index}`] = item.valueBig + item.unitName;
        });
      }
      // 订单支出 - 审核数据
      const orderApproveRes = await riskCapitalApproveData({
        codeType: 'PAY_FEE_LIMIT_SUB_TYPE',
        codeDesc: 1,
        state: 1,
      });
      if (!orderApproveRes.failed && orderApproveRes) {
        this.approveBtnState = true;
        orderApproveRes.items.forEach((item, index) => {
          this.detailData.order.tableData.approveData[`order${index}`] = item.valueBig + orderRes.items[index].unitName;
        });
      }
    },
    async getDriverData () {
      // 司机工资 - 原始数据
      const driverRes = await riskCapital({
        codeType: 'PAY_FEE_LIMIT_SUB_TYPE',
        codeDesc: 2,
        state: 1,
      });
      if (!driverRes.failed) {
        this.detailData.driver.tableData.title = [];
        driverRes.items.forEach((item, index) => {
          let remark = '';
          switch (index) {
            case 0:
              remark = '在驾驶员档案中设置基本工资时，如果超过此金额，系统不允许提交。';
              break;
            case 1:
              remark = '在驾驶员档案中设置补贴时，如果超过此金额，系统不允许提交。';
              break;
            case 2:
              remark = '在驾驶员工资中，单月工资不能超过此金额，否则工资单无法发送成功。';
              break;
            default:
              break;
          }
          this.detailData.driver.tableData.title.push({
            prop: `driver${index}`,
            label: item.subTypeName,
            remark,
          });
          this.detailData.driver.tableData.data[`driver${index}`] = item.valueBig + item.unitName;
        });
      }
      // 司机工资 - 审核数据
      const driverApproveRes = await riskCapitalApproveData({
        codeType: 'PAY_FEE_LIMIT_SUB_TYPE',
        codeDesc: 2,
        state: 1,
      });
      if (!driverApproveRes.failed && driverApproveRes) {
        this.approveBtnState = true;
        driverApproveRes.items.forEach((item, index) => {
          this.detailData.driver.tableData.approveData[`driver${index}`] = item.valueBig + driverRes.items[index].unitName;
        });
      }
    },
    async getMemberData () {
      // 会员消费 - 原始数据
      const memberRes = await riskCapital({
        codeType: 'PAY_FEE_LIMIT_SUB_TYPE',
        codeDesc: 3,
        state: 1,
      });
      if (!memberRes.failed) {
        this.detailData.member.tableData.title = [];
        memberRes.items.forEach((item, index) => {
          let remark = '';
          switch (index) {
            case 0:
              remark = '司机扫码加油时，如果单次消费超过此金额，系统不允许提交。';
              break;
            case 1:
              remark = '司机扫码加油消费，一天不能超此次数。';
              break;
            case 2:
              remark = '当给非自有车油卡时，系统会自动从尾款中扣除油卡押金金额，待油卡归还后将自动将押金归还到司机账户。';
              break;
            default:
              break;
          }
          this.detailData.member.tableData.title.push({
            prop: `member${index}`,
            label: item.subTypeName,
            remark,
          });
          this.detailData.member.tableData.data[`member${index}`] = item.valueBig + item.unitName;
        });
      }
      // 会员消费 - 审核数据
      const memberApproveRes = await riskCapitalApproveData({
        codeType: 'PAY_FEE_LIMIT_SUB_TYPE',
        codeDesc: 3,
        state: 1,
      });
      if (!memberApproveRes.failed && memberApproveRes) {
        this.approveBtnState = true;
        memberApproveRes.items.forEach((item, index) => {
          this.detailData.member.tableData.approveData[`member${index}`] = item.valueBig + memberRes.items[index].unitName;
        });
      }
    },
    async getAccountData () {
      // 自动打款与付款账户 - 原始数据
      const accountRes = await riskCapital({
        codeType: 'PAY_FEE_LIMIT_SUB_TYPE',
        codeDesc: 4,
        state: 1,
      });
      if (!accountRes.failed) {
        this.detailData.account.tableData.title = [];
        accountRes.items.forEach((item, index) => {
          let remark = '';
          switch (index) {
            case 0:
              remark = '如果设置成是，则只要公司平台账户有钱，系统会自动完成支付；如果设置成否，则需要在公司支付功能中进行打款操作。';
              break;
            case 1:
              remark = '支付自有车运费时，默认使用的公司账户类型。';
              break;
            case 2:
              remark = '支付司机工资时，默认使用的公司账户类型。';
              break;
            case 3:
              remark = '支付其他费用时，如借支、报销等，默认使用的公司账户类型。';
              break;
            case 4:
              remark = '司机使用虚拟油到要求现付的油站加油时，为保证油站能够及时收到加油资金，请确保账户有充足的资金，系统将自动打款给油站。';
              break;
            case 5:
              remark = '如果设置成是，则在公司支付时，需要输入支付密码；如果设置成否，则在公司支付时，无需输入支付密码。';
              break;
            case 6:
              remark = '如果设置成是，则在车辆档案中进行北斗缴费时，系统自动支付；如果设置成否，则在车辆档案中进行北斗缴费时，需要在公司支付功能中进行打款操作。';
              break;
            default:
              break;
          }
          this.detailData.account.tableData.title.push({
            prop: `account${index}`,
            label: item.subTypeName,
            remark,
          });
          if (index === 1 || index === 2 || index === 3) {
            this.detailData.account.tableData.data[`account${index}`] = item.payType;
          } else {
            this.detailData.account.tableData.data[`account${index}`] = item.value === 1 ? '是' : '否';
          }
        });
      }
      // 自动打款与付款账户 - 审核数据
      const accountApproveRes = await riskCapitalApproveData({
        codeType: 'PAY_FEE_LIMIT_SUB_TYPE',
        codeDesc: 4,
        state: 1,
      });
      if (!accountApproveRes.failed && accountApproveRes) {
        this.approveBtnState = true;
        accountApproveRes.items.forEach((item, index) => {
          if (index === 1 || index === 2 || index === 3) {
            this.detailData.account.tableData.approveData[`account${index}`] = item.payType;
          } else {
            this.detailData.account.tableData.approveData[`account${index}`] = item.value === 1 ? '是' : '否';
          }
        });
      }
    },
    async getData () {
      this.approveBtnState = false;
      this.approveFlag = false;
      this.loading = true;
      await this.getOrderData();
      await this.getDriverData();
      await this.getMemberData();
      await this.getAccountData();
      this.loading = false;
    },
  },
  mounted () {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
@import 'styles/config.scss';
.orderStatusBox {
  overflow: auto;
}
.orderInfoBox {
  margin: 16px 12px 0;
  min-height: 124px;
  border: 1px solid $border-color;
  padding: 24px 16px;
  box-sizing: border-box;
  .title {
    font-size: 16px;
    height: 16px;
    line-height: 16px;
    padding-bottom: 16px;
  }
  .desc,
  .time {
    color: #666;
    line-height: 16px;
  }
  .desc {
    padding-bottom: 12px;
  }
}
.box {
  border-top: 1px solid $border-color;
  border-left: 1px solid $border-color;
  border-right: 1px solid $border-color;
}
.itemLabel {
  background: $grey;
}
.itemLabel,
.itemText {
  height: 48px;
  line-height: 48px;
  padding: 0 24px;
  box-sizing: border-box;
  border-bottom: 1px solid $border-color;
}
.editBtn {
  margin-left: 16px;
}
</style>
